import React, { useState } from 'react';
import { Button, WideAlert, Icons, Checkbox } from '@components';

import { mdiCommentAlertOutline } from '@mdi/js';

export const ParcelaAdicionalForm = ({
  dadosParcelaAdicional,
  handleRegistraOpcao,
}) => {
  const [termoAceite, setTermoAceite] = useState(false);

  return (
    <div className="card">
      <div className="card-body">
        <p className="ts-20 fw-bold">Informativo:</p>
        <p className="ts-14 mt-2 text-muted">
          Declaro ter recebido todas as informações e esclarecimentos
          necessários para a tomada de decisão, assumindo total responsabilidade
          pela minha escolha. Estou ciente e de acordo com as seguintes
          condições:
        </p>
        <ul className="ts-14 ms-0 my-2 ps-4 lh-base text-muted mb-32">
          <li>
            A parcela adicional não se trata de Abono Anual (13º), mas sim de
            uma retirada extra do saldo remanescente da conta de aposentadoria,
            paga em dezembro.
          </li>
          <li>Seu valor é igual ao da parcela variável paga em novembro.</li>
          <li>O pagamento ocorre em dezembro, junto com o benefício mensal.</li>
          <li>
            A opção pelo recebimento deve ser feita anualmente, entre 1º e 30 de
            novembro.
          </li>
          <li>
            O pedido pode ser cancelado até às 23h59 do dia 30 de novembro.
          </li>
        </ul>
        <hr />
        {dadosParcelaAdicional.CdConsistencia === '0' ? (
          <>
            <div className="d-flex mt-32 fw-bold">
              <Checkbox
                className="beneficiario_checkbox"
                defaultChecked={termoAceite}
                onChange={() => {
                  setTermoAceite(!termoAceite);
                }}
                label="Manifesto, portanto, minha opção pelo recebimento da parcela adicional no próximo mês de dezembro do ano vigente."
              />
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                <div className="row">
                  <div className="col-12 col-lg-4 mb-3 ">
                    <Button
                      disabled={!termoAceite}
                      className="mt-4"
                      onClick={() => {
                        handleRegistraOpcao('S');
                      }}
                    >
                      Solicitar
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <WideAlert className="mb-4 mt-4" iconClear={false}>
            <div className="d-block d-lg-flex align-items-center">
              <Icons
                path={mdiCommentAlertOutline}
                color="var(--primary-color)"
                size={2}
                style={{ marginRight: 4 }}
              />
              <p className="ts-16">
                <strong>Aviso importante:</strong>{' '}
                {dadosParcelaAdicional.MsgConsistencia}
              </p>
            </div>
          </WideAlert>
        )}
      </div>
    </div>
  );
};
